/**
 * Preferences dictionary
 */
export class Preferences {
  constructor (preferences = []) {
    for (const { name, value } of preferences) {
      this[name] = value
    }
  }
}
